import locationPinSmall from "assets/images/location-pin-small.svg";
import classNames from "classnames";
import {yourPharmacy as strings} from "strings";

import Map from "components/Map";
import MobileNavigationHeader from "components/MobileNavigationHeader";
import PageTitle from "components/PageTitle";

import {useCurrentPharmacy} from "lib/useCurrentPharmacy";

import styles from "./YourPharmacyPage.module.css";

export default function YourPharmacyPage() {
  const [pharmacy] = useCurrentPharmacy();

  function formatPhoneNumber(phoneNumber: string) {
    return `(${phoneNumber.substring(0, 3)}) ${phoneNumber
      .toString()
      .substring(3, 6)}-${phoneNumber.substring(6)}`;
  }

  if (!pharmacy) {
    return null;
  }

  return (
    <div>
      <MobileNavigationHeader backTo="/profile" />
      <PageTitle className={styles.h1}>{strings.title}</PageTitle>
      <div className={styles.pharmacyName}>
        <img
          src={locationPinSmall}
          alt={"location pin"}
          className={styles.location}
        />
        <p className={styles.bold16}>{pharmacy.name}</p>
      </div>
      <section className={styles.section}>
        <Map
          center={{lat: +pharmacy.latitude, lng: +pharmacy.longitude}}
          className={styles.map}
        />
      </section>
      <section className={classNames(styles.section, styles.infoBox)}>
        <a
          className={classNames(styles.bold16, styles.colorText, styles.link)}
          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
            `${pharmacy.address.street1} ${pharmacy.address.street2} ${pharmacy.address.city}, ${pharmacy.address.state} ${pharmacy.address.zip}`,
          )}`}
          target="_blank"
          rel="noreferrer"
        >
          {`${pharmacy.address.street1} ${pharmacy.address.street2 ?? ""}`}
          <br />
          {`${pharmacy.address.city}, ${pharmacy.address.state} ${pharmacy.address.zip}`}
        </a>
        <a
          className={classNames(styles.bold16, styles.colorText, styles.link)}
          href={`tel:${pharmacy.phone}`}
        >
          {formatPhoneNumber(pharmacy.phone)}
        </a>
      </section>
    </div>
  );
}
